import { render, staticRenderFns } from "./product-records.vue?vue&type=template&id=40d85cb6&"
import script from "./product-records.vue?vue&type=script&lang=js&"
export * from "./product-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports